<template>
<div class="chapter">
<div class="inner_page">
<h1 class="titlepage"><a id="page_3"></a>Diabetes Cooking <span class="orange"><b>101</b></span></h1>
<p class="subtitle"><span><b><span class="small">MASTER DIABETES COOKING WITH<br/>101 GREAT RECIPES</span></b></span></p>
<p class="author"><span><b><span class="sm">EDITED BY</span> Perrin Davis</b></span></p>
<p class="editor"><span><img alt="Image" src="images/edu.jpg"/></span></p>
<p class="editor1"><span><span class="small">AN</span> A<span class="small">GATE IMPRINT</span></span></p>
<p class="editor1x"><span><span class="small">CHICAGO</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?6ece4043